import { Box } from '@mui/material';
import Modal from '@mui/material/Modal';
import './style.scss';

import { CloseIcon } from '../../../assets/icons/close-icon';

interface Props {
  heading: string;
  open: boolean;
  popupContent?: string;
  handleClose?: () => void;
}
export default function PopUpFooter({
  open,
  handleClose,
  heading,
  popupContent,
}: Props) {
  return (
    <div>
      <Modal className="custom_footer_modal text-editor-content" open={open}>
        <Box className={`content-style`}>
          <div className="model-header flex justify-between items-center">
            <div className="flex gap-3 items-center">
              <span className="text-black text-[20px] font-medium leading-[11px]">
                {heading}
              </span>
            </div>
            {handleClose && (
              <div onClick={handleClose} className="cursor-pointer">
                <CloseIcon />
              </div>
            )}
          </div>
          <div
            className="description-style overflow-auto"
            style={{ lineHeight: 1.5 }}
            dangerouslySetInnerHTML={{
              __html: popupContent || '',
            }}
          />
        </Box>
      </Modal>
    </div>
  );
}
